<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header card-header-grey">
        <h4 class="card-title ">Mentions Légales</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <div class="page-categories">
              <ul class="nav nav-pills nav-pills-danger nav-pills-icons justify-content-center" role="tablist">
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#link7" role="tablist">
                    <i class="material-icons">info</i> Propriétaire
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link active" data-toggle="tab" href="#link8" role="tablist">
                    <i class="material-icons">location_on</i> Editeur
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#link9" role="tablist">
                    <i class="material-icons">gavel</i> Hébergement
                  </a>
                </li>
                <!--<li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#link10" role="tablist">
                    <i class="material-icons">gavel</i> Protection des données
                  </a>
                </li>-->
              </ul>
              <div class="tab-content tab-space tab-subcategories">
                <div class="tab-pane" id="link7">
                  <div class="card no-shadow">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                          <h2>Mentions légales</h2>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12">

                          Dénomination sociale : <br />
                          Code NAF : <br />
                          Numéro de SIREN <br />
                          Numéro de TVA Intracommunautaire : <br />
                          Siège social : <br />
                          Téléphone : <br />
                          Représentant légal : <br />
                          Hébergement : <br />
                          Autorité de tutelle : <br /><br />

                          L’éditeur s’engage à respecter l’ensemble des lois concernant la mise en place et l’activité d’un site Internet.<br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane active" id="link8">
                  <div class="card no-shadow">
                    <div class="card-body">
                      <br>Société Activitae Emploi / Logiciel RHPROFILER
                      <br>2, rue Jules Védrines – 31400 Toulouse
                      <br>Tél. : 08 99 15 99 16*
                      <br>SIRET : 411 237 159 000 24
                      <br>*(0,80€ /min)
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="link9">
                  <div class="card no-shadow">
                    <div class="card-body">
                      Asp Serveur
                      <br>785 voie Antiope – 13600 La Ciotat
                      <br>Tel : 08 05 36 08 88
                      <br>SIRET : 451 777 254 000 33
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="link10">
                  <div class="card no-shadow">
                    <div class="card-body">
                      POLITIQUE DE PROTECTION DES DONNEES<br />
                      V1 du 01.02.2019<br /><br /><br />



                      L’engagement d’ACTIVITAE EMPLOI en matière de protection des données à caractère personnel va au-delà du simple respect d’une contrainte légale. Il procède avant tout de notre volonté de travailler avec nos Clients et leurs Candidats dans une relation guidée par le respect et la confiance. Conformément à cette philosophie, la protection de vos données personnelles apparait essentielle à nos yeux.<br/><br /><br />



                      Lorsque vous utilisez les produits, services et sites internet d’ACTIVITAE EMPLOI, vous nous confiez vos données personnelles. Cette politique de protection et confidentialité des données a été conçue pour vous exposer de manière globale les raisons et la manière dont nous collectons et traitons vos données. Nous vous informons de façon plus précise lors de la collecte effective d’informations.<br /><br /><br />



                      Table des matières<br /><br />

                      Définitions.<br />
                      Champ d’application et réglementation applicable.<br />
                      Quelles données recueillons-nous et comment les utilisons-nous ?<br />
                      Vous êtes un Candidat ?<br />
                      Vous êtes un Client ?<br />
                      Vous êtes un Prospect ?<br />
                      Vous êtes un Visiteur ?<br />
                      Nos pratiques de démarchage commercial<br />
                      Partageons-nous vos données personnelles ?<br />
                      Utilisons-nous des cookies et autres traceurs ?<br />
                      Où hébergeons-nous vos données personnelles ?<br />
                      Comment protégeons-nous vos données personnelles ?<br />
                      Comment exercer les droits dont vous disposez sur vos données ?<br />
                      Modifications de la politique de protection des données<br /><br />


                      1. DÉFINITIONS<br />
                      Données à caractère personnel : toute information se rapportant à une personne physique identifiée ou identifiable. Cette personne est appelée « personne concernée ».<br /><br /><br />



                      Personne concernée : personne physique qui peut être identifiée, directement ou indirectement, notamment par référence à un identifiant, tel qu’un nom, un numéro d’identification, des données de localisation, un identifiant en ligne, ou à un ou plusieurs éléments spécifiques propres à son identité physique, physiologique, génétique, psychique, économique, culturelle ou sociale.<br /><br /><br />



                      Traitement de données à caractère personnel : toute opération ou tout ensemble d’opérations effectuées ou non à l’aide de procédés automatisés et appliquées à des données ou des ensembles de données à caractère personnel, telles que la collecte, l’enregistrement, l’organisation, la structuration, la conservation, l’adaptation ou la modification, l’extraction, la consultation, l’utilisation, la communication par transmission, la diffusion ou toute autre forme de mise à disposition, le rapprochement ou l’interconnexion, la limitation, l’effacement ou la destruction.<br /><br /><br />



                      Responsable de traitement : personne physique ou morale, autorité publique, service ou autre organisme qui, seul ou conjointement avec d’autres, détermine les finalités (le « pourquoi ? ») et les moyens (le « comment ? ») du traitement.<br /><br /><br />



                      Sous-traitant : personne physique ou morale, autorité publique, service ou autre organisme qui traite des données à caractère personnel pour le compte du responsable du traitement.<br /><br /><br />



                      2. CHAMP D’APPLICATION ET RÉGLEMENTATION APPLICABLE<br />
                      Nous accordons la plus grande importance à la confidentialité de vos données. La présente politique de protection s’applique à l’ensemble des données recueillies et traitées par ACTIVITAE EMPLOI par le biais de nos interactions avec vous à travers tous nos produits, services et sites internet. Nos engagements et notre transparence sont uniformes et, par conséquent, valables quel que soit le mode de collecte ou de traitement des données.<br /><br />

                      Notre politique énonce les grands principes et principales lignes directrices d’ACTIVITAE EMPLOI en matière de protection de la vie privée sans que ces derniers ne s’y limitent. ACTIVITAE EMPLOI s’engage à respecter l’ensemble des obligations réglementaires applicables, notamment le règlement européen 2016/679 du 27 avril 2016 relatif à la protection des personnes physiques à l’égard du traitement des données à caractère personnel et à la libre circulation de ces données et la loi n° 78-17 du 6 janvier 1978 modifiée relative à l’informatique, aux fichiers et aux libertés.<br /><br /><br />



                      3. QUELLES DONNÉES RECUEILLONS-NOUS ET COMMENT LES UTILISONS-NOUS ?<br />
                      Toutes les données traitées par ACTIVITAE EMPLOI répondent aux prérequis réglementaires quant au respect notamment des finalités, durées de conservation, destinataires et sécurité des données.<br /><br />

                      ACTIVITAE EMPLOI vous informe spécifiquement sur les traitements réalisés à partir de vos données préalablement à leur mise en œuvre, par exemple via des clauses légales insérées dans nos outils et contrats. Vous trouverez néanmoins ci-dessous quelques éléments d’ordre général sur nos traitements de données.<br /><br /><br />



                      3.1. VOUS ÊTES UN CANDIDAT ?<br />
                      ACTIVITAE EMPLOI traite essentiellement ces catégories de données vous concernant :<br /><br />

                      Données d’identification (nom, prénom, email, numéro de téléphone) ;<br />
                      Données relatives à la situation professionnelle (C.V., lettre de motivation, etc.) ;<br />
                      Données relatives aux tests et entretiens (tests psychotechniques, comptes-rendus d’entretiens, etc.).<br />
                      Les données sont traitées essentiellement pour la sélection des candidats aux offres d’emplois. Les destinataires en sont :<br /><br />

                      Les équipes ACTIVITAE EMPLOI – et leurs sous-traitants éventuels, encadrés le cas échéant – en charge de vos candidatures ;<br />
                      Les recruteurs auxquels vous adressez votre candidature sur offre ou spontanément ;<br />
                      Les recruteurs auxquels votre candidature est transmise par un intermédiaire tel qu’un cabinet de recrutement.<br />
                      Vos données sont conservées pendant la durée des campagnes de recrutements auxquelles vous participez, soit 2 ans à compter du recueil de votre consentement dans la plupart des cas. Cette période (de même que d’autres modalités du traitement) pourrait être augmentée/diminuée par le responsable de traitement (le recruteur) – avec votre accord – afin qu’il puisse continuer à vous transmettre des offres d’emplois pertinentes. La durée de conservation effective vous sera communiquée par le responsable de traitement dans ses mentions légales relatives à la protection de vos données personnelles.<br /><br /><br />



                      3.2 VOUS ÊTES UN CLIENT ?<br />
                      ACTIVITAE EMPLOI traite essentiellement ces catégories de données vous concernant :<br /><br />

                      Données d’identification (nom, prénom, coordonnées) ;<br />
                      Données professionnelles (entreprise, service, poste etc.) ;<br />
                      Données de facturation.<br />
                      Vos données sont traitées principalement pour la mise en œuvre de nos outils et le respect des engagements contractuels pris dans le cadre de notre collaboration :<br /><br />

                      Gestion des services de support client ;<br />
                      Gestion et accompagnement pour vos recrutements ;<br />
                      Etc.<br />
                      Les destinataires de tout ou partie de vos données sont essentiellement les équipes ACTIVITAE EMPLOI – et leurs sous-traitants éventuels, encadrés le cas échéant – en charge de votre dossier.<br /><br />

                      Vos données sont conservées pendant la durée de notre relation contractuelle, augmentée de 3 ans à des fins de prospection commerciale et/ou d’une durée équivalente à la durée de prescription applicable à des fins de preuve.<br /><br /><br />



                      3.3 VOUS ÊTES UN PROSPECT ?<br />
                      ACTIVITAE EMPLOI traite essentiellement ces catégories de données vous concernant :<br /><br />

                      Données d’identification (nom, prénom, coordonnées) ;<br />
                      Données professionnelles (entreprise, service, poste etc.).<br />
                      Vos données sont traitées afin de promouvoir nos produits et services, en lien avec vos besoins opérationnels. Les destinataires de ces données sont les équipes ACTIVITAE EMPLOI – et leurs sous-traitants éventuels, encadrés le cas échéant – en charge du développement commercial.<br /><br />

                      Vos données sont conservées jusqu’à 3 ans à partir du dernier contact émanant de votre part.<br /><br /><br />



                      3.4 VOUS ÊTES UN VISITEUR ?<br />
                      Puisque nous n’avons pas encore le plaisir de vous connaitre, nous ne traitons aucune donnée vous concernant à l’exception des cookies. Pour en savoir plus sur nos cookies, rendez-vous ici : 6. Utilisons-nous des cookies et autres traceurs ?<br /><br /><br />



                      4. NOS PRATIQUES DE DÉMARCHAGE COMMERCIAL<br />
                      ACTIVIT@E EMPLOI n’utilise en aucun cas les données des Candidats à des fins de protection commerciale. Par ailleurs nous ne cédons aucunement vos données.<br /><br />

                      S’agissant de nos Clients et Prospects nous respectons strictement la réglementation en vigueur quel que soit le canal (courrier postal, courrier électronique, SMS/MMS, etc.). Pour en savoir plus, rendez-vous ici : 3. Quelles données recueillons-nous et comment les utilisons-nous ?<br /><br />

                      Par ailleurs lorsque vous nous avez accordé votre confiance et avez manifesté un intérêt  pour la transmission d’informations pertinentes sur nos produits et services, en phase avec vos besoins, vous conservez la capacité de revenir à tout moment sur votre décision.<br /><br /><br />



                      5. PARTAGEONS-NOUS VOS DONNÉES PERSONNELLES ?<br />
                      Hormis les hypothèses de transferts encadrés de données évoquées ci-après et les envois de données des Candidats aux recruteurs, ACTIVITAE EMPLOI ne cède ni ne partage aucune donnée personnelle vous concernant.<br /><br /><br />



                      6. UTILISONS-NOUS DES COOKIES ET AUTRES TRACEURS ?<br />
                      Les « cookies » sont de petits fichiers texte déposés par un site web ou application sur votre terminal (ordinateur, tablette ou téléphone). Ils sont utilisés principalement pour :<br /><br />

                      Permettre le fonctionnement technique d’un site web ;<br />
                      Recueillir des statistiques ;<br />
                      Développer une expérience et un environnement personnalisés concernant un utilisateur (par exemple lorsqu’un service en ligne se souvient de votre profil d’utilisateur sans que vous ayez eu à vous connecter).<br />
                      Lorsque vous visitez notre site web, nous pouvons recueillir de ce type d’informations. Consultez notre page consacrée aux cookies pour en apprendre davantage.<br /><br />

                      7. OÙ HÉBERGEONS-NOUS VOS DONNÉES PERSONNELLES ?<br />
                      Les données traitées par ACTIVIT@E EMPLOI sont hébergées en Europe, très majoritairement en France puis en Allemagne pour des raisons essentiellement techniques.<br /><br />

                      Si ACTIVITAE EMPLOI était amenée à transférer une partie de vos données en dehors du pays de la collecte initiale, voire vers des pays non-membres de l’Espace Économique Européen dont les législations en matière de protection des données à caractère personnel diffèrent de celles de l’Union Européenne, ACTIVITAE EMPLOI s’assurerait, avant de transférer vos données, que les entités extérieures à l’Union européenne et les conditions du transfert offrent un niveau de protection adéquat conformément à la réglementation européenne en vigueur (mécanismes d’autorégulation tel que le Privacy Shield, clauses contractuelles types, autorisations CNIL, etc.).<br /><br /><br />



                      8. COMMENT PROTÉGEONS-NOUS VOS DONNÉES PERSONNELLES ?<br />
                      Il est primordial pour ACTIVITAE EMPLOI de protéger vos données et votre vie privée.<br /><br />

                      ACTIVITAE EMPLOI veille à protéger et sécuriser vos données afin d’assurer leur confidentialité et empêcher qu’elles ne soient déformées, endommagées, détruites ou divulguées à des tiers non autorisés. Les mesures prises sont d’ordre :<br /><br />

                      Organisationnel : habilitations, procédures de traitement des données permettant d’assurer que seules les personnes ayant besoin de vos données dans le cadre de leurs missions y accèdent (ces personnes étant soumises à une obligation de confidentialité) ;<br />
                      Physique/matériel : protection de nos locaux, chiffrement de nos outils de travail, choix de prestataires d’hébergements fiables dont la sécurité est largement reconnue ;<br />
                      Logique : mise en œuvre d’outils de sécurité (antivirus, pare-feu, systèmes anti-intrusions, etc.), sécurisation des postes informatiques et périphériques réseaux,<br />
                      Par ailleurs nous faisons réaliser de manière régulière des audits de sécurité par des tiers spécialisés et nous nous engageons à corriger les vulnérabilités détectées dans les délais les plus courts.<br /><br /><br />



                      9. COMMENT EXERCER LES DROITS DONT VOUS DISPOSEZ SUR VOS DONNÉES ?<br />
                      Vous disposez selon votre situation d’un droit d’accès, de rectification, d’opposition pour motifs légitimes, de portabilité, de limitation et d’effacement relativement à l’ensemble des données vous concernant dans les conditions prévues par le règlement « RGPD » 2016/679 du 27 avril 2016. Vous disposez par ailleurs du droit de définir des directives relatives au sort de vos données à caractère personnel après votre mort dans les conditions prévues par la loi « pour une République Numérique » n°2016-1321 du 7 octobre 2016. Vous disposez enfin du droit de vous opposer sans frais à ce que des données vous concernant fassent l’objet d’un traitement à des fins de prospection notamment commerciale par ACTIVITAE EMPLOI (pour mémoire, si vous êtes Candidat, nous ne traitons en aucun cas vos données à cette fin).<br /><br />

                      Vous pouvez exercer vos droits en vous adressant à ACTIVITAE EMPLOI par email à data-protection@rhprofiler.com ou par courrier postal à destination du Data Protection Officer d’ACTIVITAE EMPLOI, 2 Rue Jules Védrines, 31400 Toulouse, en accompagnant votre demande de tout élément permettant d’attester de votre identité.<br /><br />

                      Par respect du souci de transparence ayant guidé la conception de la présente politique de protection et confidentialité des données, ACTIVITAE EMPLOI vous informe que vous disposez du droit d’introduire une réclamation auprès d’une autorité de contrôle relativement aux traitements de données mis en œuvre tel qu’indiqué précédemment ainsi qu’à l’exercice de vos droits s’y rattachant.<br /><br />

                      En France, il s’agit de la CNIL : https://www.cnil.fr/fr/plaintes<br /><br /><br />



                      10. MODIFICATIONS DE LA POLITIQUE DE PROTECTION DES DONNÉES<br />
                      La présente politique de protection des données peut changer à tout moment en fonction des évolutions légales, réglementaires, jurisprudentielles et doctrinales (doctrine de la CNIL notamment).<br /><br />

                      Nous publierons toute modification sur cette page et, dans le cas où il s’agirait de modifications significatives, sur d’autres pages du présent site internet à travers des encarts dédiés ou bandeaux d’informations. Tout changement devant être porté expressément à la connaissance des personnes concernées par un traitement de données le sera par exemple par le biais d’une communication email.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
